import React from "react";
import { Link } from "react-router-dom";
import { EpicomLogo } from "./brand/Logo";
import SectionLabel from "./brand/SectionLabel";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-bg-primary border-t border-steel-dark pt-20 pb-10"
    >
      {/* Giant wordmark — full-width wrapper so it can center independently of the container's max-width.
          Size clamped so it never overflows on ultrawide monitors. */}
      <div
        aria-hidden="true"
        className="hidden md:block text-center heading text-white/5 leading-none select-none pointer-events-none overflow-hidden"
        style={{ fontSize: "clamp(120px, 22vw, 360px)" }}
      >
        EPICOM
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-steel-dark -mt-4 md:-mt-[12vw] relative">
          <div className="md:col-span-5">
            <EpicomLogo className="h-12 w-auto mb-6" />
            <p className="text-steel-light text-sm leading-relaxed max-w-sm">
              Epicom Systems Ltd. — Communications contracting for farms,
              businesses and homes across Southern Alberta.
            </p>
          </div>

          <div className="md:col-span-3">
            <SectionLabel className="mb-5">Services</SectionLabel>
            <ul className="space-y-2 text-sm text-steel-light">
              <li><a href="/cellular-das" data-testid="footer-service-das" className="hover:text-signal transition-colors">Cellular DAS</a></li>
              <li><a href="/unifi-installation" data-testid="footer-service-unifi" className="hover:text-signal transition-colors">UniFi Installation</a></li>
              <li><a href="/business-wifi" data-testid="footer-service-wifi" className="hover:text-signal transition-colors">Business Wi-Fi</a></li>
              <li><a href="/point-to-point-wireless" data-testid="footer-service-ptp" className="hover:text-signal transition-colors">Point-to-Point Wireless</a></li>
              <li><a href="/#service-cell-boosters" data-testid="footer-service-cell-boosters" className="hover:text-signal transition-colors">Cell Boosters</a></li>
              <li><a href="/#service-security" data-testid="footer-service-security" className="hover:text-signal transition-colors">Security & Access Control</a></li>
              <li><a href="/#service-towers" data-testid="footer-service-towers" className="hover:text-signal transition-colors">Towers & Wireless Infrastructure</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <SectionLabel className="mb-5">Contact</SectionLabel>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:rod@epicom.ca"
                  data-testid="footer-email"
                  className="text-white hover:text-signal transition-colors"
                >
                  rod@epicom.ca
                </a>
              </li>
              <li className="text-steel-light">Southern Alberta, Canada</li>
              <li>
                <a
                  href="/#contact"
                  data-testid="footer-cta-quote"
                  className="inline-block mt-2 font-mono text-[11px] tracking-[0.25em] uppercase border border-signal text-signal hover:bg-signal hover:text-white px-5 py-3 transition-all"
                >
                  Request Quote →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between pt-8 gap-4">
          <div className="font-mono text-[11px] tracking-[0.2em] text-steel-light uppercase">
            ©{" "}
            <Link
              to="/login"
              data-testid="footer-secret-admin-link"
              aria-label="Admin"
              title=""
              className="text-steel-light hover:text-signal transition-colors duration-700 select-none cursor-default"
              style={{ textDecoration: "none" }}
            >
              {year}
            </Link>{" "}
            Epicom Systems Ltd. · All Signals Reserved.
          </div>
          <div className="font-mono text-[11px] tracking-[0.2em] text-steel-light uppercase">
            <Link
              to="/designs"
              data-testid="footer-designs-link"
              className="hover:text-signal transition-colors"
            >
              Need a Website? · Epicom Designs →
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
